import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription, Subject } from 'rxjs';

import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../dynamicDataSet.module.config';
import { AddDynamicDataSetModel } from '../models/AddDynamicDataSetModel';
import { DynamicDataSetModel } from '../models/DynamicDataSetModel';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { ActionBase } from '../../core/store/action/ActionBase';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';

@Component({
  selector: 'brd-add-dynamic-dataset-dialog',
  templateUrl: './add-dynamic-dataset-dialog.component.html',
  styleUrls: ['./add-dynamic-dataset-dialog.component.scss']
})
export class AddDynamicDataSetDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  loading: boolean;
  addActionIdentifier: string;

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<AddDynamicDataSetDialogComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions) {
    this.addForm = formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern('[A-Za-z]*'), Validators.maxLength(100)])]
    });
  }

  ngOnInit() {
    this.actions$.ofType(actions.addSuccessType<AddDynamicDataSetModel>(ModuleConfiguration.moduleName, AddDynamicDataSetModel))
      .takeUntil(this.destroyed$)
      .subscribe((a: actions.AddSuccessAction<AddDynamicDataSetModel>) => {
        this.router.navigateByUrl('dynamic-dataset-workspace/' + a.payload.key);
        this.loading = false;
        this.addActionIdentifier = undefined;
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.addActionIdentifier && a.payload.action.identifier === this.addActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((a: ActionError) => {
        this.loading = false;
        this.addActionIdentifier = undefined;
        a.payload.errors.forEach(e => this.alerts.addError(e));        
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  add() {
    var model = new AddDynamicDataSetModel();
    model.name = this.addForm.value.name;
    var addAction = new actions.AddAction(ModuleConfiguration.moduleName, AddDynamicDataSetModel, { model: model });
    this.addActionIdentifier = addAction.identifier;
    this.store.dispatch(addAction);
    this.loading = true;
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/components/add-dynamic-dataset-dialog.component.ts